import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { questions } from "./Data";
import { CreateBar } from "./PercentageBar";
import { DetailedResults } from "./DetailedResults";
import "./PersonalityAssessment.css";
import { connect } from "react-redux";
import { myFirestore } from "../../../services/firebase";

let eP = 0,
  aP = 0,
  cP = 0,
  nP = 0,
  oP = 0; //percentage values of each domain

function ScoreCard() {
  const [showResults, setShowResults] = useState(false);
  function handleShowResults() {
    if (!showResults) {
      setShowResults(true);
    } else {
      setShowResults(false);
    }
  }
  return (
    <div className="result-div-personality">
      <h3>Results</h3>
      <p>
        Thank you for taking the test. We hope you had a good experience. As we
        mentioned before, there are 5 factors that have widely been accepted to
        impact one's personality.
      </p>
      <p>
        This test assessed these 5 factors in you, namely - Openness to
        Experience (O), Conscientiousness (C), Extraversion (E), Agreeableness
        (A) and Neuroticism (N).
      </p>
      <p>On the basis of the answers you gave, here are your results: </p>
      <div className="results-graph">
        <CreateBar percentage={oP} domainID="O" />
        <CreateBar percentage={cP} domainID="C" />
        <CreateBar percentage={eP} domainID="E" />
        <CreateBar percentage={aP} domainID="A" />
        <CreateBar percentage={nP} domainID="N" />
      </div>

      <Button variant="secondary" onClick={handleShowResults}>
        Show Explanation
      </Button>
      {showResults ? <DetailedResults /> : null}
    </div>
  );
}

function PersonalityAsessmentQuiz(props) {
  const [qno, setQno] = useState(0);
  let [ansArray] = useState([]);
  const [show, setShow] = useState(true);

  let ans = 0;

  let e = 0,
    a = 0,
    c = 0,
    n = 0,
    o = 0; //Raw score for each domain

  function computeScore() {
    e =
      20 +
      ansArray[0] -
      ansArray[5] +
      ansArray[10] -
      ansArray[15] +
      ansArray[20] -
      ansArray[25] +
      ansArray[30] -
      ansArray[35] +
      ansArray[40] -
      ansArray[45];

    a =
      14 -
      ansArray[1] +
      ansArray[6] -
      ansArray[11] +
      ansArray[16] -
      ansArray[21] +
      ansArray[26] -
      ansArray[31] +
      ansArray[36] +
      ansArray[41] +
      ansArray[46];

    c =
      14 +
      ansArray[2] -
      ansArray[7] +
      ansArray[12] -
      ansArray[17] +
      ansArray[22] -
      ansArray[27] +
      ansArray[32] -
      ansArray[37] +
      ansArray[42] +
      ansArray[47];

    n =
      38 -
      ansArray[3] +
      ansArray[8] -
      ansArray[13] +
      ansArray[18] -
      ansArray[23] -
      ansArray[28] -
      ansArray[33] -
      ansArray[38] -
      ansArray[43] -
      ansArray[48];

    o =
      8 +
      ansArray[4] -
      ansArray[9] +
      ansArray[14] -
      ansArray[19] +
      ansArray[24] -
      ansArray[29] +
      ansArray[34] +
      ansArray[39] +
      ansArray[44] +
      ansArray[49];

    eP = (e / 40) * 100;
    aP = (a / 40) * 100;
    cP = (c / 40) * 100;
    nP = (n / 40) * 100;
    oP = (o / 40) * 100;

    if (props.auth.uid) {
      myFirestore
        .collection("testresults")
        .doc(props.auth.uid)
        .set(
          {
            personalityTest: {
              openness: oP,
              conscientiousness: cP,
              extroversion: eP,
              agreeableness: aP,
              neuroticism: nP,
            },
          },
          { merge: true }
        );
    } else {
      myFirestore
        .collection("anonresults")
        .doc()
        .set({
          personalityTest: {
            openness: oP,
            conscientiousness: cP,
            extroversion: eP,
            agreeableness: aP,
            neuroticism: nP,
          },
        });
    }
  }

  function handleClick(e) {
    ans = parseInt(e.target.getAttribute("data-value"));
    ansArray.push(ans);
    setQno((prev) => prev + 1);
    if (qno + 1 === 50) {
      setShow(false);
      computeScore();
    }
  }

  return (
    <div className="screen-bg">
      {show ? (
        <div className="quiz-bg">
          <p>Question {qno + 1} of 50</p>
          <h3>{questions[qno]}</h3>
          <div className="answers">
            <div data-value="1" onClick={handleClick}>
              Disagree
            </div>
            <div data-value="2" onClick={handleClick}>
              Slightly Disagree
            </div>
            <div data-value="3" onClick={handleClick}>
              Neutral
            </div>
            <div data-value="4" onClick={handleClick}>
              Slightly Agree
            </div>
            <div data-value="5" onClick={handleClick}>
              Agree
            </div>
          </div>
        </div>
      ) : (
        <ScoreCard />
      )}
      <br />
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
  };
};

export default connect(mapStateToProps)(PersonalityAsessmentQuiz);
